import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../utils/api';

const BlogCard = ({ blog, delay = 0 }) => {
  const navigate = useNavigate();

  const formatDate = (d) => new Date(d).toLocaleDateString('en-US', { 
    year: 'numeric', month: 'short', day: 'numeric' 
  });

  return (
    <div 
      className="blog-card reveal"
      style={{ transitionDelay: `${delay}ms` }}
      onClick={() => navigate(`/blog/${blog._id}`)}
    >
      <div className="blog-card-image-wrap">
        {blog.image 
          ? <img src={getImageUrl(blog.image)} alt={blog.title} className="blog-card-image" />
          : <div style={{ 
              width: '100%', aspectRatio: '16/10', 
              background: 'linear-gradient(135deg, #2C4A3E, #C9A84C)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'rgba(255,255,255,0.5)', fontSize: '2rem'
            }}>✦</div>
        }
      </div>
      <div className="blog-card-body">
        <span className="blog-card-tag">{blog.page}</span>
        <h3 className="blog-card-title">{blog.title}</h3>
        <p className="blog-card-excerpt">{blog.excerpt}</p>
        <div className="blog-card-footer">
          <span className="blog-card-date">{formatDate(blog.createdAt)}</span>
          <span className="blog-read-more">Read More <span>→</span></span>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
